import z from "zod";

export const CreateCaseSchema = z.object({
  template_id: z.string().trim().optional(),
  file: z
    .instanceof(File)
    .refine((file) => file.size > 0, "File is required")
    .refine(
      (file) => file.size <= 10 * 1024 * 1024,
      "File size must be less than 10MB"
    )
    .refine((file) => {
      const allowedTypes = [".csv", ".xls", ".docx", ".pdf"];
      const fileExtension = file.name.split(".").pop();
      return allowedTypes.includes(`.${fileExtension}`);
    }, "Invalid file type. Only CSV, XLS, DOCX, and PDF files are allowed."),
  manual_case_number: z.string().trim().optional(),
  manual_claim_number: z.string().trim().optional(),
});

export type CreateCaseFormData = z.infer<typeof CreateCaseSchema>;

export const UpdateCaseSchema = z.object({
  template_id: z.string().trim().nonempty("Required"),
  case_number: z.string().trim().nonempty("Required"),
  claim_number: z.string().trim().nonempty("Required"),
  examinee_name: z.string().trim().nonempty("Required"),
  organisation: z.string().trim(),
  service_type: z.string().trim(),
  report_due_date: z.string(),
  appointment_date: z.string(),
});

export type UpdateCaseFormData = z.infer<typeof UpdateCaseSchema>;
